import {LocalDateTime} from '@js-joda/core';
import {get} from 'lodash-es';

import {events} from '../events';

export const symbolMpidClearingReducer = {
    [events.SYMBOL_MPID_CLEARING_GET]: (state = {}) => ({
        ...state,
        isLoading: true
    }),
    [events.SYMBOL_MPID_CLEARING_SUCCESS]: (state, {payload: {data}}) => {
        const configurations = get(data, 'data.configurations', []);
        const totalCount = get(data, 'data.totalCount', 0);
        const offset = get(data, 'data.offset', 0);

        // Calculate if there are more pages: current page end < total
        const more = (offset + configurations.length) < totalCount;

        return {
            isLoading: false,
            error: false,
            more,
            rowData: configurations,
            totalCount,
            timestamp: LocalDateTime.now()
        };
    },
    [events.SYMBOL_MPID_CLEARING_ERROR]: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error
    }),

    // Create handlers
    [events.SYMBOL_MPID_CLEARING_CREATE]: (state) => ({
        ...state,
        isCreating: true,
        createError: null,
        createSuccessMessage: null
    }),

    [events.SYMBOL_MPID_CLEARING_CREATE_SUCCESS]: (state, {payload: {data}}) => ({
        ...state,
        isCreating: false,
        createError: null,
        createSuccessMessage: get(data, 'data', 'Symbol MPID clearing configuration(s) saved successfully')
    }),

    [events.SYMBOL_MPID_CLEARING_CREATE_ERROR]: (state, action) => ({
        ...state,
        isCreating: false,
        createError: action.error,
        createSuccessMessage: null
    }),

    // Delete handlers
    [events.SYMBOL_MPID_CLEARING_DELETE]: (state) => ({
        ...state,
        isDeleting: true,
        deleteError: null,
        deleteSuccessMessage: null
    }),

    [events.SYMBOL_MPID_CLEARING_DELETE_SUCCESS]: (state, {payload: {data}}) => ({
        ...state,
        isDeleting: false,
        deleteError: null,
        deleteSuccessMessage: get(data, 'data', 'Symbol MPID clearing configuration(s) deleted successfully')
    }),

    [events.SYMBOL_MPID_CLEARING_DELETE_ERROR]: (state, action) => ({
        ...state,
        isDeleting: false,
        deleteError: action.error,
        deleteSuccessMessage: null
    })
};
